import _ from 'lodash'

const ROUND_STAGES = [
  {
    label: 'Founders',
    value: 'founders',
  },
  {
    label: 'Family & Friends',
    value: 'family_friends',
  },
  {
    label: 'Pre-seed',
    value: 'pre_seed',
  },
  {
    label: 'Seed',
    value: 'seed',
  },
  {
    label: 'Pre-series A',
    value: 'pre_series_a',
  },
  {
    label: 'Series A',
    value: 'series_a',
  },
  {
    label: 'Pre-series B',
    value: 'pre_series_b',
  },
  {
    label: 'Series B',
    value: 'series_b',
  },
  {
    label: 'Series C+',
    value: 'other',
  },
]
export default ROUND_STAGES
export const roundStageChoices = ROUND_STAGES

export const roundStageChoiceByValue = _.keyBy(ROUND_STAGES, 'value')
export const roundStageChoiceByLabel = _.keyBy(ROUND_STAGES, 'label')

export function roundStageLabel(value) {
  return roundStageChoiceByValue[value].label
}
